module.exports = __webpack_public_path__ + "static/media/social-media.7246dd31.svg";